import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { ConfigContext } from "@app/provider";
import { LinkHeap } from "@app/components";
import { HeapEventProps } from "../../linkHeap/linkHeap";

import "./needHelpLink.scss";

const messages = defineMessages({
  linkContactUs: {
    id: "linkContactUs",
    defaultMessage: "Contact us",
  },
  textNeedHelp: {
    id: "scheduleBloodDrawNeedHelp",
    defaultMessage: "Need help? ",
  },
});

type NeedHelpLinkProps = {
  heapEventName?: string;
  heapEventProps?: HeapEventProps;
};

export const NeedHelpLink: FC<NeedHelpLinkProps> = ({
  heapEventName,
  heapEventProps,
}) => {
  const intl = useIntl();
  const { config } = React.useContext(ConfigContext);

  return (
    <p className="need-help">
      {intl.formatMessage(messages.textNeedHelp)}&nbsp;
      <LinkHeap
        target="_blank"
        key="privacyPolicy"
        rel="noopener noreferrer"
        to={config.links.CONTACT_US}
        heapEventName={heapEventName}
        heapEventProps={heapEventProps}
        className="need-help__link"
      >
        {intl.formatMessage(messages.linkContactUs)}
      </LinkHeap>
    </p>
  );
};
